var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreedot1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 12,
    viewBox: "0 0 3 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 0C0.6 0 0 0.6 0 1.33333C0 2.06667 0.6 2.66667 1.33333 2.66667C2.06667 2.66667 2.66667 2.06667 2.66667 1.33333C2.66667 0.6 2.06667 0 1.33333 0ZM1.33333 9.33333C0.6 9.33333 0 9.93333 0 10.6667C0 11.4 0.6 12 1.33333 12C2.06667 12 2.66667 11.4 2.66667 10.6667C2.66667 9.93333 2.06667 9.33333 1.33333 9.33333ZM1.33333 4.66667C0.6 4.66667 0 5.26667 0 6C0 6.73333 0.6 7.33333 1.33333 7.33333C2.06667 7.33333 2.66667 6.73333 2.66667 6C2.66667 5.26667 2.06667 4.66667 1.33333 4.66667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedot1);
export default __webpack_public_path__ + "static/media/threedot1.26409f9423f89ab54533d71a5ff8ee16.svg";
export { ForwardRef as ReactComponent };